import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionsComponent } from './subscriptions.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SubscriptionsTableComponent } from './subscriptions-table/subscriptions-table.component';
import { SubscriptionFormResolver } from './subscription/subscription.resolver';

const routes: Routes = [
  {
    path: '',
    component: SubscriptionsComponent,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        component: SubscriptionsTableComponent,
      },
      {
        path: 'edit/:id',
        component: SubscriptionComponent,
        resolve: { subscriptionData: SubscriptionFormResolver },
      },
      {
        path: 'add',
        component: SubscriptionComponent,
        resolve: { subscriptionData: SubscriptionFormResolver },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [SubscriptionFormResolver],
})
export class SubscriptionsRoutingModule {}
